import React from "react";

function FormSupplierOrder({ pedido }) {



const onProcessar=async()=>{}
const onCancelar=async()=>{}





  return (
    <div className="bg-white shadow-md rounded-2xl p-4">
      <h2 className="text-lg font-bold text-gray-800 mb-4">
        📦 Pedidos Recentes
      </h2>

      <ul role="list" className="divide-y divide-gray-200">
        {pedido?.length === 0 && (
          <p className="text-gray-500 text-sm">Nenhum pedido encontrado.</p>
        )}

        {pedido?.map((p) => (
          <li
            key={p.id}
            className="flex justify-between gap-x-6 py-5 hover:bg-gray-50 transition rounded-xl px-3"
          >
            <div className="flex min-w-0 gap-x-4">
              <img
                src={p.img}
                alt="Produto"
                className="h-12 w-12 rounded-full object-cover bg-gray-100"
              />

              <div className="min-w-0 flex-auto">
                <p className="text-sm font-semibold text-gray-900">
                  {p.nameProduto}
                </p>
                <p className="text-xs text-gray-500">
                  💰 Preço: {(p?.price).toFixed(2)} kz
                </p>
                <p className="text-xs text-gray-500">
                  👤 cor: {p?.cor}
                </p>
                 <p className="text-xs text-gray-500">
                  👤 Tamanho: {p?.size}
                </p>
                <p className="text-xs text-gray-500">
                  📦 Quantidade: {p?.quantity}
                </p>
              </div>
            </div>

            <div className="w-28 flex flex-col gap-2">
              <button
                onClick={() => onProcessar(pedido)}
                className="bg-green-500 hover:bg-green-600 text-white text-sm py-1 rounded-lg transition"
              >
                Processar
              </button>

              <button
                onClick={() => onCancelar(pedido)}
                className="bg-red-500 hover:bg-red-600 text-white text-sm py-1 rounded-lg transition"
              >
                Cancelar
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default FormSupplierOrder;